import { forwardRef } from 'react'
import { createLink } from '@tanstack/react-router'
import {
  Link as AriaLink,
  type LinkProps as AriaLinkProps,
} from 'react-aria-components'

import { cn } from '@/shared/lib/cn'

interface AppLinkBaseProps
  extends Omit<AriaLinkProps, 'className'> {
  className?: string
}

export const AppLink = createLink(forwardRef<
  HTMLAnchorElement,
  AppLinkBaseProps
>(function AppLinkBase(
  {
    className,
    ...props
  },
  ref,
) {
  return (
    <AriaLink
      ref={ref}
      className={cn(
        'outline-none',
        'focus-visible:ring-2',
        'focus-visible:ring-(--color-primary)',
        'focus-visible:ring-offset-2',
        className,
      )}
      {...props}
    />
  )
}))